import * as Yup from 'yup';
import { sharedTestSchemaValidation } from './RunTestSharedSchema';

export const MAX_BULK_TEST_LIMIT = 200;

export const runBulkTestSchema = (isSuperAdmin: boolean) =>
  Yup.object()
    .shape({
      bulk: Yup.string().required('Bulk name is required'),
      importedTests: Yup.array().of(sharedTestSchemaValidation(isSuperAdmin)),
      tests: Yup.array().of(sharedTestSchemaValidation(isSuperAdmin))
    })
    .test({
      name: 'at-least-one-test',
      exclusive: true,
      test: function (value) {
        const { importedTests, tests } = value;
        if (!(importedTests && importedTests.length) && !(tests && tests.length)) {
          return this.createError({
            message: 'At least one tests is required',
            path: 'importedTests'
          });
        }
        return true;
      }
    });
